
/*************
 * General
 */

const snakeToCamel = type => type.replace(/-(\w)/, (_, letter) => {
  return letter.toUpperCase();
});

// typeToService :: String -> String
export const typeToService = type => {
  switch (type) {
  case 'lift': return 'elevator';
  case 'recycling-bottle': return 'bottleRecycling';
  case 'info': return 'infoDesk';

  case 'nursery-room':
  case 'parcel-pickup':
  case 'parking-meter':
  case 'toilet-accessible': return snakeToCamel(type);

  default: return type;
  }
};

const camelToSnake = type => type.replace(/([A-Z])/, (_, letter) => {
  return '-' + letter.toLowerCase();
});

// serviceToType :: String -> String
export const serviceToType = service => {
  const identityPart = service.replace('service.', '');
  switch (identityPart) {
  case 'elevator': return 'lift';
  case 'bottleRecycling': return 'recycling-bottle';
  case 'infoDesk': return 'info';

  case 'nurseryRoom':
  case 'parcelPickup':
  case 'parkingMeter':
  case 'toiletAccessible': return camelToSnake(identityPart);

  default: return identityPart;
  }
};

// const flip = type => type.split('-').reverse().join('-');

// typeToIcon :: String -> String
export const typeToIcon = type => {
  function transform (type) {
    switch (type) {
    case 'info': return 'info-desk';
    case 'lift': return 'elevator';
    case 'recycling-bottle': return 'bottle-recycling';

    default: return type;
    }
  }
  return `svg:ic_${transform(type)}`;
};

/*************
 * Visioglobe specific
 */

export const TYPE_REGEX = /^\w+-([a-z_-]+)-\d+/;

export const ID_TO_TYPE_MAP = [
  'atm', 'bus', 'ev-charging', 'info',
  ['lift|elevator', 'lift'],
  'lockers', 'metro', 
  ['nursery-room|nursery', 'nursery-room'], 
  'parcel-pickup', 'park', 'parking', 'parking-meter', 'playgroung', 'recycling',
  ['recycling-bottle|bottle-recycling|recycle-bottles', 'recycling-bottle'],
  'taxi', 'toilet',
  ['toilet-accessible|accessible-toilet', 'toilet-accessible'],
  'train', 'tram'

].reduce((acc, x) => {
  if (typeof x == 'string') {
    acc[x] = x;
  }
  else if (Array.isArray(x)) {
    const [some, type] = x;
    some.split('|').forEach(x => acc[x] = type);
  }
  else {
    throw new Error(`Bad mapping ${x}`);
  }
  return acc;
}, {});

// idToType :: String -> String|Undefined
export const idToType = id => {
  const [, match] = id.match(TYPE_REGEX) || [];
  return ID_TO_TYPE_MAP[match];
};


/*************
 * In-house specific
 */

import { SERVICE_TYPES } from '~/models/Constants';

const SERVICE_TYPE_TO_TYPE_MAP = SERVICE_TYPES.reduce(
  (acc, x) => (acc[x.id] = serviceToType(x.name), acc), {}
);

const TYPE_TO_SERVICE_MAP = SERVICE_TYPES.reduce(
  (acc, x) => (acc[serviceToType(x.name)] = x, acc), {}
);

// serviceTypeToType :: Int -> String|Undefined
export const serviceTypeToType = id => {
  return SERVICE_TYPE_TO_TYPE_MAP[id] || {};
};

// typeToServiceType :: String -> Object
export const typeToServiceType = type => {
  return TYPE_TO_SERVICE_MAP[type] || {};
};
